import React, {useCallback} from 'react';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import {WebSocketOperationButton} from "../../components/web-socket/WebSocketOperationButton";
import {useCurrentOfficeStore} from "../../api/CurrentOfficeStore";
import {BERLIN_OFFICE_ID} from "../../util/OfficePath";
import {useNewJoinerStore} from "../../api/NewJoinerStore";
import {useNewJoinerChecklistItemStore} from "../../api/NewJoinerChecklistItemStore";

export function ImportBerlinNewJoinersButton() {
    const currentOfficeId = useCurrentOfficeStore(state => state.officeId);
    const refreshNewJoiners = useNewJoinerStore(state => state.refresh);
    const refreshChecklistItems = useNewJoinerChecklistItemStore(state => state.refresh);

    const handleFinish = useCallback(() => {
        refreshNewJoiners();
        refreshChecklistItems();
    }, [refreshNewJoiners, refreshChecklistItems]);

    return currentOfficeId === BERLIN_OFFICE_ID ? (
        <WebSocketOperationButton
            endpoint={`/api/operations/offices/${currentOfficeId}/import-berlin-new-joiners`}
            variant="outlined"
            description="Import Berlin onboarding rows from the Google spreadsheet into new joiners."
            actionButtonLabel="Import Onboardings"
            icon={<GroupAddIcon/>}
            onFinish={handleFinish}
        />
    ) : null;
}
